import { WorkspaceSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const WORKSPACE_TABLE = '"public"."workspaces"'
export const WORKSPACE_ENDPOINT = '/api/workspace'

export const WorkspaceConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: WORKSPACE_TABLE,
  partitionKey: 'slug',
  key: 'id',
  apiEndpoint: WORKSPACE_ENDPOINT,
  where: {},
  schema: WorkspaceSchema,
}
